import { __read, __assign } from 'tslib';
import { jsx } from '@emotion/react/jsx-runtime';
import { useReducer, useRef, useEffect } from 'react';
import { isFunction } from '@reach/utils';
import { reducer } from '../reducer.js';
import { OPEN_TOGGLETIP, CLOSE_TOGGLETIP } from '../actions.js';
import { ToggleTipProvider } from './ToggleTipProvider.js';

var ToggleTipBase = function (_a) {
    /**
     * Following the reducer pattern to manage context state from reach-ui `MenuButton`
     * https://github.com/reach/reach-ui/tree/main/packages/menu-button
     *
     */
    var _b = _a.direction, direction = _b === void 0 ? "up" : _b, _c = _a.isOpen, isOpen = _c === void 0 ? false : _c, _d = _a.cardOverhang, cardOverhang = _d === void 0 ? 16 : _d, _e = _a.cardGapSize, cardGapSize = _e === void 0 ? 4 : _e, onExpanded = _a.onExpanded, children = _a.children;
    var initialToggleTipState = {
        isOpen: isOpen,
        cardOverhang: cardOverhang,
        cardGapSize: cardGapSize,
        direction: direction,
    };
    var _f = __read(useReducer(reducer, initialToggleTipState), 2), state = _f[0], dispatch = _f[1];
    var buttonRef = useRef(null);
    var popoverRef = useRef(null);
    // Comments inherited from @reach:
    // We use an event listener attached to the window to capture outside clicks
    // that close the toggleTip. We don't want the initial button click to trigger this
    // when a toggleTip is closed, so we can track this behavior in a ref for now.
    // We shouldn't need this when we rewrite with state machine logic.
    var buttonClickedRef = useRef(false);
    // Comments inherited from @reach:
    // Trying a new approach for splitting up contexts by stable/unstable
    // references. We'll see how it goes!
    var context = {
        buttonRef: buttonRef,
        dispatch: dispatch,
        popoverRef: popoverRef,
        buttonClickedRef: buttonClickedRef,
        state: state,
    };
    useEffect(function () {
        if (isOpen && !state.isOpen) {
            context.dispatch({ type: OPEN_TOGGLETIP });
        }
        else if (isOpen === false && state.isOpen) {
            context.dispatch({ type: CLOSE_TOGGLETIP });
        }
    }, [isOpen]);
    useEffect(function () {
        if (state.isOpen) {
            onExpanded && onExpanded();
        }
    }, [state.isOpen]);
    // Ability to focus input/button inside the content, disabled for now
    // React.useEffect(() => {
    //   if (state.isOpen) {
    //     window.requestAnimationFrame(() => {
    //       const popoverElem = popoverRef.current;
    //       if (popoverElem) {
    //         const firstInput = (
    //           popoverElem as unknown as HTMLElement
    //         ).querySelector("input, button");
    //         !!firstInput && focus(firstInput as HTMLElement);
    //       }
    //     });
    //   }
    // }, [state.isOpen]);
    return (jsx(ToggleTipProvider, __assign({ value: context }, { children: isFunction(children)
            ? children({
                isOpen: !!state.isOpen,
            })
            : children })));
};

export { ToggleTipBase };
//# sourceMappingURL=ToggleTipBase.js.map
